// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {DescmoocsScreenLayout} from 'app_components/screens/landing/descmoocs'
// @end

// @ADD Component types
interface IDescmoocsScreenProps {}
interface IDescmoocsScreenState {}

class DescmoocsScreen extends Component<IDescmoocsScreenProps, IDescmoocsScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IDescmoocsScreenProps) {
    super(props)
    this.state = {}
  }

  render() {
    return(
      <DescmoocsScreenLayout
        {...this.props}
      />
    )
  }
}

export default DescmoocsScreen
